






















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Api from "../api/index";
// import AreaCascader from "@/components/area/index.vue";
import { pca, pcaa } from "area-data"; // 城市数据
import "vue-area-linkage/dist/index.css"; // 样式

class FormValidate {
  diyCode: string;
  displayName: string;
  province: string;
  city: string;
  district: string;
  address: string;
  principal: string;
  phoneNumber: string;
  parentId: number;
  id?: number;
}

@Component({
  components: {
    // AreaCascader
  }
})
export default class OrganizationFramework extends AbpBase {
  select: any = [];
  areaList: any = [];
  formValidate: FormValidate = new FormValidate();
  ruleValidate: any = {
    diyCode: [{ required: true, message: "代码不能为空", trigger: "blur" }],
    displayName: [
      { required: true, message: "渠道名称不能为空", trigger: "blur" }
    ],
    select: [
      {
        required: true,
        validator: (rule, value, callback) => {
          // console.log(value);
          if (value && value.length !== 3) {
            callback(new Error("请选择省市区"));
          } else {
            callback();
          }
        },
        trigger: "change"
      }
    ],
    address: [{ required: true, message: "详细地址不能为空", trigger: "blur" }],
    principal: [{ required: true, message: "负责人不能为空", trigger: "blur" }],
    phoneNumber: [
      {
        required: true,
        validator: (rule, value, callback) => {
          if (!value) {
            callback(new Error("手机号不能为空"));
          } else if (!/^1[34578]\d{9}$/.test(value)) {
            callback(new Error("手机号格式不正确"));
          } else {
            callback();
          }
        },
        trigger: "blur"
      }
    ]
  };
  hackReset: boolean = true;
  pca: any = pca;
  pcaa: any = pcaa;

  created() {
    this.getChannelDetail();
  }
  @Watch("$route")
  routeChange(to: any, old: any) {
    this.hackReset = false; //销毁组件
    this.$nextTick(() => {
      this.hackReset = true; //重建组件
    });
    this.formValidate = new FormValidate();
    if (to.name === "organizationFrameworkChannelEdit") {
      this.getChannelDetail();
    }
  }
  selectArea(value) {
    console.log(value);
    if (value[0].code === undefined) {
      value = value.map((currentValue, index, arr) => {
        return {
          code: Object.keys(currentValue)[0],
          name: Object.values(currentValue)[0]
        };
      });
      this.formValidate.province = JSON.stringify(value[0]);
      this.formValidate.city = JSON.stringify(value[1]);
      this.formValidate.district = JSON.stringify(value[2]);
    } else {
      this.formValidate.province = JSON.stringify(value[0]);
      this.formValidate.city = JSON.stringify(value[1]);
      this.formValidate.district = JSON.stringify(value[2]);
    }
    // console.log(this.formValidate);
  }
  handleSubmit(name) {
    const formValidate: any = this.$refs[name];
    if (this.$route.params.id == undefined) {
      this.formValidate.parentId = Number(this.$route.params.parentId);
    }
    formValidate.validate(valid => {
      if (valid) {
        if (this.select && this.select.length !== 3) {
          this.$Message.warning("请选择省市区");
        } else {
          // console.log(this.formValidate);
          Api.editChannel(this.formValidate).then(res => {
            // console.log(res);
            this.$Message.success("保存成功");
            setTimeout(() => {
              this.$router.go(-1);
            }, 1000);
          });
        }
      }
    });
  }
  getChannelDetail() {
    if (this.$route.params.id) {
      Api.getChannelDetail(this.$route.params.id).then(res => {
        const {
          parentId,
          address,
          city,
          diyCode,
          displayName,
          district,
          id,
          phoneNumber,
          principal,
          province
        } = res.data.result;
        let tempArr = [];
        tempArr[0] = JSON.parse(province).code;
        tempArr[1] = JSON.parse(city).code;
        tempArr[2] = JSON.parse(district).code;
        this.select = tempArr;
        this.formValidate = {
          parentId,
          address,
          city,
          diyCode,
          displayName,
          district,
          id,
          phoneNumber,
          principal,
          province
        };
      });
    }
  }
}
